import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useParams } from 'react-router-dom';

import Loader from '../../Loader/Loader';
import ClubAllEventCard from './ClubAllEventCard';

import './ClubAllEvents.css'

const EVENT_URL = "/events"

function ClubAllEvents() {

    const [events, setEvents] = useState('')
    let { id } = useParams();

    useEffect(() => {
      async function getClubs() {
        try {
          const response = await axios.get(process.env.REACT_APP_DEPT_API + EVENT_URL);
          setEvents(response.data);
        } catch (error) {
          console.error(error);
        }
      }
      getClubs()
    }, [])

    const clubsEve = events && events.filter(x => x.club === id)

  return (
    <div className="admin">
      <div className='clubEvents'>
          <div className='section__container'>
              <div className='section'>
                  <h1 className='section__header'>All Events</h1>
                  <div className='clubEvents__container'>
                      {clubsEve ? clubsEve.map((eve) => (
                          <ClubAllEventCard 
                              key={eve._id}
                              id={eve._id}
                              club={eve.club}
                              collaborating_clubs={eve.collaborating_clubs}
                              description={eve.description}
                              event_date={eve.event_date}
                              organizing_club={eve.organizing_club}
                              poster_image={eve.poster_image.url}
                              registration_deadline={eve.registration_deadline}
                              registration_link={eve.registration_link}
                              title={eve.title}
                              venue={eve.venue}
                          />
                      )) : <Loader color="#AE9142" size={70}/>}
                  </div>
              </div>
          </div>
      </div>
    </div>
  )
}

export default ClubAllEvents